export enum LanguageEnum {
  ENGLISH = 'en',
  HEBREW = 'he',
  YIDDISH = 'yi',
}